import * as TYPES from './mutationTypes';

export default {
  [TYPES.SET_MAP_LOADED_STATE](state, response) {
    state.hasMapLoaded = response;
  },
};
